import {
    ESTACIO_INICIALITZAR,
    ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_EN_CURS,
    ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_FINALITZADA
} from '../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioEstacionsEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_FINALITZADA:
            return false;

        case ESTACIO_VISUALITZACIO_OMPLIR_ESTACIONS_EN_CURS:
            return true;

        default:
            return state;
    }
};

export default peticioEstacionsEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/estacio/peticioEstacionsEnCurs.js